export enum ThemeVariant {
    PRIMARY_DARK = 'primary-dark',
    PRIMARY_MEDIUM = 'primary-medium',
    SECONDARY = 'white',
    TERTIARY = 'gray',
    PRIMARY = 'primary'
}
